export default function Footer() {
    return (
      <footer className="footer">
        © {new Date().getFullYear()} Sevanand
      </footer>
    );
  } 